var _circle, _circle2, _circle3, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2517,
    cy: 23.2517,
    r: 23.2517,
    fill: "#37C290",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2514,
    cy: 23.2514,
    r: 19.5014,
    fill: "#37C290",
    fillOpacity: 0.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.2511,
    cy: 24.0016,
    r: 15.7511,
    fill: "#37C290"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0774 17.8055C27.0774 17.2877 26.5957 16.9045 26.0911 17.021L16.4293 19.2506C16.0639 19.3349 15.8052 19.6602 15.8052 20.0352V32.1948H15.4026C15.1802 32.1948 15 32.3751 15 32.5974C15 32.8197 15.1802 33 15.4026 33H16.2061H16.2077H16.2093H19.8309V30.5845C19.8309 30.1398 20.1914 29.7794 20.6361 29.7794H22.2464C22.6911 29.7794 23.0516 30.1398 23.0516 30.5845V33H26.6732H26.6748H26.6764H27.0774V17.8055ZM18.6232 21.7278C18.4009 21.7278 18.2206 21.908 18.2206 22.1304V22.9355C18.2206 23.1579 18.4009 23.3381 18.6232 23.3381H19.4284C19.6507 23.3381 19.8309 23.1579 19.8309 22.9355V22.1304C19.8309 21.908 19.6507 21.7278 19.4284 21.7278H18.6232ZM18.2206 24.5459C18.2206 24.3235 18.4009 24.1433 18.6232 24.1433H19.4284C19.6507 24.1433 19.8309 24.3235 19.8309 24.5459V25.351C19.8309 25.5733 19.6507 25.7536 19.4284 25.7536H18.6232C18.4009 25.7536 18.2206 25.5733 18.2206 25.351V24.5459ZM18.6232 26.5587C18.4009 26.5587 18.2206 26.739 18.2206 26.9613V27.7665C18.2206 27.9888 18.4009 28.1691 18.6232 28.1691H19.4284C19.6507 28.1691 19.8309 27.9888 19.8309 27.7665V26.9613C19.8309 26.739 19.6507 26.5587 19.4284 26.5587H18.6232ZM20.6361 22.1304C20.6361 21.908 20.8163 21.7278 21.0387 21.7278H21.8438C22.0661 21.7278 22.2464 21.908 22.2464 22.1304V22.9355C22.2464 23.1579 22.0661 23.3381 21.8438 23.3381H21.0387C20.8163 23.3381 20.6361 23.1579 20.6361 22.9355V22.1304ZM21.0387 24.1433C20.8163 24.1433 20.6361 24.3235 20.6361 24.5459V25.351C20.6361 25.5733 20.8163 25.7536 21.0387 25.7536H21.8438C22.0661 25.7536 22.2464 25.5733 22.2464 25.351V24.5459C22.2464 24.3235 22.0661 24.1433 21.8438 24.1433H21.0387ZM20.6361 26.9613C20.6361 26.739 20.8163 26.5587 21.0387 26.5587H21.8438C22.0661 26.5587 22.2464 26.739 22.2464 26.9613V27.7665C22.2464 27.9888 22.0661 28.1691 21.8438 28.1691H21.0387C20.8163 28.1691 20.6361 27.9888 20.6361 27.7665V26.9613ZM23.4541 21.7278C23.2318 21.7278 23.0516 21.908 23.0516 22.1304V22.9355C23.0516 23.1579 23.2318 23.3381 23.4541 23.3381H24.2593C24.4816 23.3381 24.6619 23.1579 24.6619 22.9355V22.1304C24.6619 21.908 24.4816 21.7278 24.2593 21.7278H23.4541ZM23.0516 24.5459C23.0516 24.3235 23.2318 24.1433 23.4541 24.1433H24.2593C24.4816 24.1433 24.6619 24.3235 24.6619 24.5459V25.351C24.6619 25.5733 24.4816 25.7536 24.2593 25.7536H23.4541C23.2318 25.7536 23.0516 25.5733 23.0516 25.351V24.5459ZM23.4541 26.5587C23.2318 26.5587 23.0516 26.739 23.0516 26.9613V27.7665C23.0516 27.9888 23.2318 28.1691 23.4541 28.1691H24.2593C24.4816 28.1691 24.6619 27.9888 24.6619 27.7665V26.9613C24.6619 26.739 24.4816 26.5587 24.2593 26.5587H23.4541Z",
    fill: "url(#paint0_linear_3500_38849)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8848 19.8687V33H29.8965H29.8977H29.8988H30.7028C30.9251 33 31.1054 32.8197 31.1054 32.5974C31.1054 32.3751 30.9251 32.1948 30.7028 32.1948H30.3002V21.574C30.3002 21.2691 30.1279 20.9903 29.8551 20.8539L27.8848 19.8687Z",
    fill: "url(#paint1_linear_3500_38849)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.247 33H20.6367V30.5845H22.247V33Z",
    fill: "url(#paint2_linear_3500_38849)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3500_38849",
    x1: 21.0387,
    y1: 17.8,
    x2: 21.0387,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3500_38849",
    x1: 29.4951,
    y1: 20.5252,
    x2: 29.4951,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3500_38849",
    x1: 21.4419,
    y1: 30.7053,
    x2: 21.4419,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.1f89ceb483a93da36034c4f4892a24df.svg";
export { ForwardRef as ReactComponent };